var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.222)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.222)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 35.5,
    rx: 34.5,
    ry: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 35.5,
    rx: 33,
    ry: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.333,5.771a15.169,15.169,0,0,1-4.285,1.176,7.521,7.521,0,0,0,3.281-4.13,15.416,15.416,0,0,1-4.743,1.8,7.463,7.463,0,0,0-12.717,6.8A21.142,21.142,0,0,1,2.488,3.635,7.314,7.314,0,0,0,1.477,7.39,7.464,7.464,0,0,0,4.8,13.6a7.439,7.439,0,0,1-3.38-.934v.091A7.468,7.468,0,0,0,7.4,20.081a7.578,7.578,0,0,1-3.355.129,7.487,7.487,0,0,0,6.984,5.183,14.967,14.967,0,0,1-9.256,3.193A15.841,15.841,0,0,1,0,28.485a21.228,21.228,0,0,0,11.463,3.351C25.2,31.835,32.7,20.465,32.7,10.622c0-.319,0-.637-.023-.956A15.07,15.07,0,0,0,36.4,5.8Z",
    transform: "translate(17.75 17.476)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f0c6e26ad1dfb8e3bb5f5a167140289b.svg";
export { ForwardRef as ReactComponent };